import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem("asfa_auth")) { setLoading(false); return; }  // no hint = logged out, skip the 401 probe
    api.get("/auth/me").then((r) => setUser(r.data.user))
      .catch(() => { localStorage.removeItem("asfa_auth"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    const me = await api.get("/auth/me").catch(() => null);
    localStorage.setItem("asfa_auth", "1");
    setUser(me?.data?.user || r.data.user);
    return me?.data?.user || r.data.user;
  };
  const signup = async (email, password, name) => {
    const r = await api.post("/auth/signup", { email, password, name });
    const me = await api.get("/auth/me").catch(() => null);
    localStorage.setItem("asfa_auth", "1");
    setUser(me?.data?.user || r.data.user);
    return me?.data?.user || r.data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("server logout failed; clearing local session anyway:", e); }
    localStorage.removeItem("asfa_auth");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, signup, logout, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
